
export const RELATIONSHIP_TYPES = [
    "Sibling",
    "Relative",
    "Friend",
    "Co-Worker",
    "Spouse",
    "Well Wisher",
    "Custom"
];